export const ADVISOR_CONNECTION_STATUSES = {
  pendingSignUpByUser: 'pending-sign-up-by-user',
  pendingEthAddressFromUser: 'pending-eth-address-from-user',
  pendingTransactionSigningByBoth: 'pending-transaction-signing-from-both',
  pendingTransactionSigningByUser: 'pending-transaction-signing-from-user',
  pendingTransactionSigningByCompany: 'pending-transaction-signing-from-company',
  signedByBoth: 'signed-by-both',
  rejectedByUser: 'rejected-by-user',
  unknown: 'unknown',
  softStatusPendingAtUser: 'soft-status-pending',
  softStatusPendingValidationByUser: 'soft-status-validation-pending',
  softStatusPendingApprovalByCompany: 'soft-status-pending-approval-company',
  softStatusAcceptedByBoth: 'soft-status-accepted-by-both',
  softStatusRejectionConfirmedByBoth: 'soft-status-rejection-confirmed-by-both',
  softStatusDisapprovedByCompany: 'soft-status-disapproved-by-admin',
};

export const ADVISOR_CONNECTION_TYPES = {
  soft: 'soft',
  smartContract: 'smart-contract',
};

export function calculateAdvisorConnectionType(advisorConnection) {
  return advisorConnection && advisorConnection.softConnection
    ? ADVISOR_CONNECTION_TYPES.soft
    : ADVISOR_CONNECTION_TYPES.smartContract;
}

export function calculateAdvisorConnectionStatus(advisorConnection) {
  if (advisorConnection) {
    const type = calculateAdvisorConnectionType(advisorConnection);
    if (type === ADVISOR_CONNECTION_TYPES.soft) {
      const { status, statusValidatedByUserAt, companyStatus } = advisorConnection.softConnection;
      if (status === 'PENDING') return ADVISOR_CONNECTION_STATUSES.softStatusPendingAtUser;
      else if (statusValidatedByUserAt) {
        if (companyStatus === 'APPROVED') {
          if (status === 'ACCEPTED') return ADVISOR_CONNECTION_STATUSES.softStatusAcceptedByBoth;
          if (status === 'REJECTED')
            return ADVISOR_CONNECTION_STATUSES.softStatusRejectionConfirmedByBoth;
          return ADVISOR_CONNECTION_STATUSES.unknown;
        } else if (companyStatus === 'DISAPPROVED') {
          return ADVISOR_CONNECTION_STATUSES.softStatusDisapprovedByCompany;
        } else return ADVISOR_CONNECTION_STATUSES.softStatusPendingApprovalByCompany;
      } else return ADVISOR_CONNECTION_STATUSES.softStatusPendingValidationByUser;
    }

    if (type === ADVISOR_CONNECTION_TYPES.smartContract) {
      // if (advisorConnection.status === 'verified') return ADVISOR_CONNECTION_STATUSES.signedByBoth;
      if (advisorConnection.rejectedTimestamp) return ADVISOR_CONNECTION_STATUSES.rejectedByUser;
      else if (advisorConnection.signedByUser && advisorConnection.signedByCompany)
        return ADVISOR_CONNECTION_STATUSES.signedByBoth;
      else if (!advisorConnection.user) return ADVISOR_CONNECTION_STATUSES.pendingSignUpByUser;
      else if (advisorConnection.user && !advisorConnection.user.ethereumAddress)
        return ADVISOR_CONNECTION_STATUSES.pendingEthAddressFromUser;
      else if (advisorConnection.user && advisorConnection.user.ethereumAddress) {
        if (
          typeof advisorConnection.signedByCompany === 'undefined' &&
          typeof advisorConnection.signedByUser === 'undefined'
        )
          return ADVISOR_CONNECTION_STATUSES.unknown;
        else if (!advisorConnection.signedByCompany && !advisorConnection.signedByUser)
          return ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByBoth;
        else if (!advisorConnection.signedByCompany)
          return ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByCompany;
        else if (!advisorConnection.signedByUser)
          return ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByUser;
      }
    }

    return ADVISOR_CONNECTION_STATUSES.unknown;
  }

  return undefined;
}



// WEBPACK FOOTER //
// ./src/store/features/company-advisor-connections/helpers.js